
























































import {Mixins, Component} from 'vue-property-decorator';
import PageSizeData from '@/components/board/mixins/PageSizeData';
import PageTitle from '@/components/common/PageTitle.vue';
import PageFormSelect from '@/components/board/common/PageFormSelect.vue';
import AdminListTop from '@/components/admin/AdminListTop.vue';
import PageTabMenu from '@/components/admin/common/PageTabMenu.vue';
import PageFormBtn from '@/components/board/common/PageFormBtn.vue';
import ItemTable from '@/components/common/ItemTable.vue';
import {RadioRenderer, escapeHtml} from '@/utils/commonUtils';
import ExcelCreateButton from '@/components/common/grid/ExcelCreateButton.vue';
import ReasonDetailLayerPopup from '@/components/ReasonDetailLayerPopup.vue';

@Component({
  components: {
    PageTitle,
    PageFormSelect,
    AdminListTop,
    PageTabMenu,
    PageFormBtn,
    ItemTable,
    ExcelCreateButton,
    ReasonDetailLayerPopup
  }
})
export default class AdminList extends Mixins(PageSizeData) {
  private searchTypeData = [
    {value: 'ALL', label: this.toI18n('ADMIN_LIST_ALL')}, // 전체
    {value: 'ADMIN_NAME', label: this.toI18n('ADMIN_LIST_OPERATOR_NAME')}, // 운영자명
    {value: 'ADMIN_NO', label: this.toI18n('ADMIN_LIST_OPERATOR_NO')}, // 운영자번호
    {value: 'ADMIN_ID', label: this.toI18n('ADMIN_LIST_ID')}, // 아이디
    {value: 'DEPARTMENT_NAME', label: this.toI18n('ADMIN_LIST_DEPARTMENT_NAME')} // 소속부서
  ];

  private adminListParams: any = {
    searchType: 'ALL',
    keyword: '',
    page: 1,
    pageSize: 30
  };

  private reasonDetailModal = { isOpen: false, reasonDetail: '' };

  private closeReasonDetailModal() {
    this.reasonDetailModal.isOpen = false
  }

  private openReasonDetailModal() {
    if (!this.getCheckedItems('adminNo')) {
      alert(this.toI18n('ADMIN_LIST_ALERT_SELECT_OPERATOR'));

      return;
    }

    this.reasonDetailModal.isOpen = true;
  }

  private confirmReasonDetailModal(value: string) {
    this.reasonDetailModal.reasonDetail = value;

    if (!this.reasonDetailModal.reasonDetail) {
      alert('사유를 입력해주세요.');

      return;
    }

    this.closeReasonDetailModal();
    this.deleteAdmin();
  }

  private get excelParams () {
    return {
      searchType: this.adminListParams.searchType,
      keyword: this.adminListParams.keyword,
    };
}

  private getCheckedItems(propName: string): string {
    return (this.$refs.itemTable as any).getCheckedItems(propName);
  }

  private deleteAdmin() {
    const targetNo = this.getCheckedItems('adminNo');
    sessionStorage.setItem('adminNo', targetNo);
    if (targetNo) {
      const {no: adminNo} = JSON.parse(localStorage.getItem('adminInfo'));
      const isTargetSelf = parseInt(targetNo) === parseInt(adminNo);
      const deleteConfirmMessage = this.toI18n('ADMIN_LIST_CONFIRM_MESSAGE');
      const deleteConfirmSelfMessage = this.toI18n('ADMIN_LIST_CONFIRM_SELFMESSAGE');
      const deleteCompleteMessage = this.toI18n('ADMIN_LIST_ALERT_COMPELET');

      if (!isTargetSelf && !confirm(deleteConfirmMessage)) {
        return;
      }

      if (isTargetSelf && !confirm(deleteConfirmSelfMessage)) {
        return;
      }

      this.$api.deleteAdminsServiceByAdminNo({
        params: {
          adminNo: targetNo,
          reasonDetail: this.reasonDetailModal.reasonDetail,
        }
      }).then(() => {
        alert(deleteCompleteMessage);
        if (isTargetSelf) {
          this.$router.push('/logout');
        } else {
          this.search();
        }
      });
    } else {
      alert(this.toI18n('ADMIN_LIST_ALERT_SELECT_OPERATOR'));
    }
  }

  private adminData = [] as any;
  private totalCount: number = 0;
  private size: number = 30;
  private gridProps = {
    columns: [
      {
        header: this.toI18n('ADMIN_LIST_ID'), // 아이디
        name: 'adminId',
        minWidth: 100,
        align: 'left',
        formatter: ({value, row}: any) => {
          if (value !== null) {
            return `<a href="/admin/modification/${row.adminNo}">${escapeHtml(value)}</a>`;
          }

          return '';
        }
      },
      {
        header: this.toI18n('ADMIN_LIST_OPERATOR_NAME'), // 운영자명
        name: 'adminName',
        minWidth: 80
      },
      {
        header: this.toI18n('ADMIN_LIST_OPERATOR_NO'), // 운영자번호
        name: 'adminNo',
        minWidth: 80
      },
      {
        header: this.toI18n('ADMIN_LIST_RANK'), // 직급
        name: 'jobPositionName',
        align: 'center',
        minWidth: 60
      },
      {
        header: this.toI18n('ADMIN_LIST_TYPE'), // 유형
        name: 'adminRole',
        align: 'center',
        minWidth: 80,
        formatter: ({value}: any) => {
          if (value === 'MASTER') {
            return this.toI18n('ADMIN_LIST_MASTER'); // 마스터
          } else if (value === 'NORMAL') {
            return this.toI18n('ADMIN_LIST_NORMAL'); // 일반
          }

          return value;
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: this.toI18n('ADMIN_LIST_AUTHORITY_GROUP_NAME'), // 권한그룹명
        name: 'authorityGroupName',
        align: 'center',
        minWidth: 120,
        formatter: ({row, value}: any) => {
          return row.adminRole === 'MASTER' ? '-' : value;
        },
      },
      {
        header: this.toI18n('ADMIN_LIST_DEPARTMENT_NAME'), // 소속부서
        name: 'departmentName',
        minWidth: 90,
        align: 'center'
      },
      {
        header: this.toI18n('ADMIN_LIST_POSITION'), // 직책
        name: 'jobDutyName',
        minWidth: 60,
        align: 'center'
      },
      {
        header: this.toI18n('ADMIN_LIST_OTP_YN'),
        name: 'otp',
        align: 'center',
        minWidth: 100,
        formatter: ({ value: otp }) => {
          const used = !!otp?.['used'];
          
          return used ? 'Y' : 'N'
        },
      },
      {
        header: this.toI18n('ADMIN_LIST_STATE'), // 상태
        align: 'center',
        minWidth: 80,
        name: 'adminStatus',
        formatter: ({value}: any) => {
          if (value === 'ACTIVE') {
            return this.toI18n('ADMIN_LIST_FINISHED_APPOINTMENT'); // 등록완료
          } else if (value === 'WAITING') {
            return this.toI18n('ADMIN_LIST_WAIT_FOR_REGISTRATION'); // 등록대기
          } else if (value === 'INVESTIGATION') {
            return this.toI18n('ADMIN_LIST_UNDER_REVIEW'); // 검토중
          } else if (value === 'LOCKED') {
            return this.toI18n('ADMIN_LIST_LOGIN_LOCK'); // 로그인 잠금
          } else if (value === 'DELETE') {
            return this.toI18n('ADMIN_LIST_DELETE'); // 삭제
          } else if (value === 'DORMANT') {
            return this.toI18n('ADMIN_LIST_DORMANCY'); // 휴면
          }

          return this.toI18n('ADMIN_LIST_STATE_ANOMALIES'); // 상태 이상
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: this.toI18n('ADMIN_LIST_EXPIRED'), // 만료여부
        align: 'center',
        minWidth: 50,
        name: 'expired',
        formatter: ({value}: any) => {
          return !value ? 'N' : 'Y';
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: this.toI18n('ADMIN_LIST_E-MAIL'), // 이메일
        name: 'email',
        align: 'left',
        minWidth: 180,
        formatter: ({row}: any) => {
          return row.contactInfo.email;
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: this.toI18n('ADMIN_LIST_PHONE_NUMBER'), // 전화번호
        name: 'phoneNo',
        align: 'center',
        minWidth: 90,
        formatter: ({row}: any) => {
          return row.contactInfo.phoneNo;
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: this.toI18n('ADMIN_LIST_MOBILE_PHONE_NUMBER'), // 휴대폰번호
        name: 'mobileNo',
        align: 'center',
        minWidth: 90,
        formatter: ({row}: any) => {
          return row.contactInfo.mobileNo;
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: this.toI18n('ADMIN_LIST_EXTERNAL_CONNECTION'), // 외부접속
        align: 'center',
        name: 'externalAccessEnabled',
        minWidth: 50,
        formatter: ({value}: any) => {
          return value ? '가능' : '불가';
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: this.toI18n('ADMIN_LIST_DATE_OF_REGISTRATION'), // 계정등록일시
        minWidth: 130,
        align: 'center',
        name: 'createdDateTime'
      },
      {
        header: this.toI18n('ADMIN_LIST_EXPIRED_DATE'), // 계정만료일시
        minWidth: 130,
        align: 'center',
        name: 'expireDateTime',
        formatter: ({value}: any) => {
          return !!value ? value : this.toI18n('LIMIT_N');
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: this.toI18n('ADMIN_LIST_PASSWORD_CHANGE_DATE'), // 비밀번호변경일시
        minWidth: 130,
        align: 'center',
        name: 'passwordUpdatedDateTime'
      },
      {
        header: this.toI18n('ADMIN_LIST_LAST_LOGIN_DATE'), // 최종로그인 일시
        minWidth: 130,
        align: 'center',
        name: 'lastLoginDateTime'
      }
    ],
    header: {
      height: 33
    },
    options: {
      rowHeaders: [
        {
          name: 'radioBtn',
          type: 'radio',
          header: this.toI18n('ADMIN_LIST_SELECT'), // 선택
          renderer: RadioRenderer
        }
      ],
      columnOptions: {
        minWidth: 50,
        resizable: true
      },
      minRowHeight: 31,
      rowHeight: 31,
      minBodyHeight: 190,
      bodyHeight: 190,
      isInitialRequest: true,
      useClientSort: false,
      pageOptions: {
        perPage: 30,
        page: 1,
        totalCount: 0
      }
    }
  };
  private contentBottomOption = {
    haveConfigBtn: false,
    haveExcelDownBtn: false
  };

  private search(page: number = 1, size?: number) {
    if (size) {
      this.adminListParams.pageSize = size;
      this.size = size;
    }
    if (this.adminListParams.searchType !== 'ALL' && !this.adminListParams.keyword) {
      alert(this.toI18n('ADMIN_LIST_ALERT_SEARCH'));
      return;
    }
    Object.assign(this.adminListParams, {page});

    this.$api.getAdminsService({params: {...this.adminListParams}}).then((respones: any) => {
      const data = respones.data;
      this.adminData = data.contents;
      this.totalCount = data.totalCount;
      this.gridProps.options.pageOptions.page = page;
      this.gridProps.options.pageOptions.perPage = this.size;
      this.gridProps.options.pageOptions.totalCount = data.totalCount;
    });
  }

  private reset() {
    Object.assign(this.adminListParams, {
      page: 1,
      pageSize: this.size,
      searchType: 'ALL',
      keyword: ''
    });
  }
}
